// src/pages/Authentication.jsx
import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../utils/msalConfig';
import { useNavigate } from 'react-router-dom';
import { checkUserRole } from '../utils/authUtils';
import styles from './Login.module.css';

const Authentication = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const [loginError, setLoginError] = useState('');

    const handleLoginClick = async () => {
        try {
            const response = await instance.loginPopup(loginRequest);
            
            if (response.account) {
                const email = response.account.username;
                const isAdmin = await checkUserRole(email);
                const destination ='/meetings';
                navigate(destination);
            }
        } catch (error) {
            setLoginError('Login failed. Please try again.');
        }
    };

    return (
        <div className="relative w-full h-screen flex items-center justify-center bg-black overflow-hidden">
            <video
                autoPlay
                loop
                muted
                className="absolute top-0 left-0 w-full h-full object-cover"
                src="https://redrocket.energy/wp-content/uploads/2024/05/RedRocketAnimation1200p_Loop.mp4"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 z-[-1] font-avenir"></div>
            <div className="relative bg-white bg-opacity-5 rounded-2xl shadow-xl p-8 text-center max-w-md w-full">
                <h1 className="text-2xl font-bold text-white">Welcome to Red Rocket Event Manager</h1>
                <p className="text-white mt-2">Sign in to browse available meetings.</p>
                {loginError && <div className="mt-4 text-sm text-red-600">{loginError}</div>}
                <button 
                    onClick={handleLoginClick} 
                    className="mt-6 bg-black text-white px-6 py-3 rounded-lg shadow-md hover:bg-red-700 transition-all"
                >
                    Log In with Microsoft
                </button>
            </div>
        </div>
    );
};

export default Authentication;

